import React from 'react';
import {SInputWrapper, SLabel, SErrorMessage} from '../input/styled/SInput';
import SSelect from 'react-select';
import { ValueType } from "react-select/lib/types";

interface SelectOption {
    label: string;
    value: string;
}

interface SelectProps {
    placeholder?: string;
    value: SelectOption | undefined;
    label?: string;
    name: string;
    onChange: (selected: ValueType<SelectOption>) => void;
    onBlur: () => void;
    options: SelectOption[];
    id: string;
    reset?: boolean;
    defaultValue?: any;
    error?: string;
    touched?: boolean;
    required?: boolean;
}

function getBorderColor() {
    if (window.location.host.includes('bcd')) {
        return '#cccccc';
    }
    return '#777777';
}

function Select(props: SelectProps) {

    return (

        <React.Fragment>
            {props.label && <SLabel>{props.label} <span className="asterisk">{props.required && '*'}</span></SLabel> }
            <SInputWrapper>
                <SSelect className={'select'} placeholder={props.value && props.value.label} theme={(theme) => ({
                    ...theme,
                    spacing: {
                        menuGutter: 0,
                        baseUnit: theme.spacing.baseUnit,
                        controlHeight: theme.spacing.controlHeight
                    },
                    colors: {
                        ...theme.colors,
                        primary: '#000066',
                    },
                    borderRadius: 0
                })} styles={{control: (base, state) => ({
                    ...base,
                    border: (props.error && props.touched) ? '1px solid #cc0033' : `1px solid ${getBorderColor()}`,
                    padding: '8px 6px',
                    boxShadow: 'none',
                    fontSize: '13px',
                    backgroundColor: (props.error && props.touched) ? '#fffafb;' : 'white',
                    '&:hover': { borderColor: `${getBorderColor()}` },
                    'svg': {color: props.error ? '#cc0033' : `${getBorderColor()}`}
                })}} components={{IndicatorSeparator: () => null}} isMulti={false} reset={props.reset} value={props.value} onBlur={props.onBlur} label={props.label} onChange={props.onChange} options={props.options} id={props.id} />
                {props.error && <SErrorMessage id={`error-${props.id}`}>{props.touched && props.error}</SErrorMessage>}
            </SInputWrapper>
        </React.Fragment>
    );
}

export default Select;
